import styled from "styled-components";

export const ContainerDiv = styled.div`
  max-width: 2000px;
  display: flex;
  flex-direction: column;
  padding: 10px 15px;
  color: #1e2228;
  box-sizing: border-box;

  @media (max-width: 940px) {
    padding: 93px 30px;
  }
`;


export const Button = styled.button`
  background: #ffffff;
  mix-blend-mode: normal;
  border: 1px solid #1b49ea;
  border-radius: 6px;
  color: #1b49ea;
  padding: 10px 15px;
  margin-left: 10px;
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 17px;
  background-color: ${props=>props.disabled&&'#cccccc'};
  pointer-events:${(props)=>props.disabled?'none':null};
`;

export const SecondaryButton = styled.button`
  background: #1b49ea;
  mix-blend-mode: normal;
  border: 1px solid #1b49ea;
  border-radius: 6px;
  color: white;
  padding: 10px 15px;
  margin-left: 10px;
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 17px;
`;